import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Honest solo-founder journey. Grounded in docs/content/08 + the real EAKC-MVP repo:
//   - Supabase India block: docs/content/08 §"THE SUPABASE INDIA BLOCK"
//   - 22% sync hang / patched fetch / setTimeout worker: docs/2026-02-19-sync-hang-connection-pool-fix.md
//   - tenant_id from mig 001, RLS mig 002 (multi-tenant from day one)
//   - MCP 3 tools query_eakc/list_sources/get_document: src/lib/mcp/tools.ts
//   - revenue $0 / pre-launch / OpenClaw failure: docs/content/08

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "I built an AI product solo in two months. Then my government blocked my database." },
];

export const ORIGIN: ScriptLine[] = [
  { scene: "origin", fromSec: 0.4, holdSec: 6, caption: "I was an engineer at Microsoft. Stable, fine — but I wanted to own every decision, end to end." },
  { scene: "origin", fromSec: 6.6, holdSec: 6, caption: "So I left, and built EAKC: connect your knowledge sources, sync them, ask in plain English with cited answers." },
];

export const STACK: ScriptLine[] = [
  { scene: "stack", fromSec: 0.4, holdSec: 7, caption: "I picked boring technology on purpose — Postgres, not a trendy vector DB. TypeScript, not Rust. Next.js, not a custom framework." },
  { scene: "stack", fromSec: 7.6, holdSec: 7.5, caption: "The whole production stack runs on about twenty-five dollars a month. The constraint forced better decisions." },
];

export const BLOCK: ScriptLine[] = [
  { scene: "block", fromSec: 0.4, holdSec: 6, caption: "One morning the Supabase dashboard wouldn't load. Timeout. Different browser — timeout. New router — timeout." },
  { scene: "block", fromSec: 6.6, holdSec: 6.5, caption: "Supabase was up globally. Then Twitter: the Indian government had blocked it at the ISP level." },
  { scene: "block", fromSec: 13.3, holdSec: 6, caption: "My entire database platform was unreachable from my own machine. No dashboard, no migrations, no local testing." },
];

export const SAVED: ScriptLine[] = [
  { scene: "saved", fromSec: 0.4, holdSec: 6.5, caption: "The saving grace: production was fine. Railway sits in the US, Hostinger in Europe — they could still reach Supabase." },
  { scene: "saved", fromSec: 7.1, holdSec: 6.5, caption: "Geographic diversity saved me. Workaround: a VPN for development. Every push took three times longer, but it worked." },
];

export const RIGHT: ScriptLine[] = [
  { scene: "right", fromSec: 0.4, holdSec: 7, caption: "What went right: multi-tenant from the first commit. Every table carries a tenant_id, every query filters by it, RLS enforces it in the database." },
  { scene: "right", fromSec: 7.6, holdSec: 7, caption: "And I built the RAG pipeline incrementally — vector search, then hybrid, then reranking — each layer on a stable base." },
];

export const WRONG: ScriptLine[] = [
  { scene: "wrong", fromSec: 0.4, holdSec: 7, caption: "What went wrong: I ran the sync worker inside Next.js. It hung at 22% for three days — the framework's patched fetch was deadlocking the event loop." },
  { scene: "wrong", fromSec: 7.6, holdSec: 7.5, caption: "And a full week building an OpenClaw integration that the platform simply ignored. I should have tested its limits before building." },
];

export const MONEY: ScriptLine[] = [
  { scene: "money", fromSec: 0.4, holdSec: 6, caption: "The honest financials: revenue is zero. The product is pre-launch. No paying customers yet." },
  { scene: "money", fromSec: 6.6, holdSec: 6.5, caption: "No hockey-stick graph. Most solo SaaS fails — I might too. But the technical depth doesn't depreciate." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 6.5, caption: "The best code came from constraints, not comfort. A one-gigabyte server taught me more than any course." },
  { scene: "outro", fromSec: 7.3, holdSec: 6, caption: "The code is real. The deployment is real. The bugs were real. If you're building solo — it's possible. Not easy. Possible." },
  { scene: "outro", fromSec: 14, holdSec: 5, caption: "Next: why a big lab's no-code AI worker doesn't kill what I built." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
